import { Injectable } from '@angular/core';
import { httpResource } from '@angular/common/http';
import { environment } from '@app/env';
import { DictionaryItem, LanguageOption } from '@app/shared/models';

type DictionaryType = 'countries' | 'transports' | 'skilllevels' | 'drivinglicenses';

@Injectable({ providedIn: 'root' })
export class DictionaryApiService {
  getDictionaryResource(type: DictionaryType) {
    return httpResource<DictionaryItem[]>(() => `${environment.apiBaseUrl}/dictionaries/${type}`);
  }

  getLanguagesResource(onlyPrimary = false) {
    return httpResource<LanguageOption[]>(() => ({
      url: `${environment.apiBaseUrl}/dictionaries/languages`,
      params: { onlyPrimary },
    }));
  }
}
